(function () {
  'use strict';

  function openPanel(panel) {
    panel.hidden = false;
    panel.style.setProperty('--kpm-acc-h', panel.scrollHeight + 'px');
    requestAnimationFrame(function () { panel.classList.add('is-open'); });
  }
  function closePanel(panel) {
    panel.style.setProperty('--kpm-acc-h', panel.scrollHeight + 'px');
    requestAnimationFrame(function () {
      panel.classList.remove('is-open');
      panel.addEventListener('transitionend', function handler() {
        panel.hidden = true;
        panel.removeEventListener('transitionend', handler);
      });
    });
  }

  function initAcc(acc) {
    var toggles = acc.querySelectorAll('[data-kpm-acc-toggle]');
    toggles.forEach(function (btn, idx) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        if (expanded) {
          btn.setAttribute('aria-expanded', 'false');
          closePanel(panel);
        } else {
          btn.setAttribute('aria-expanded', 'true');
          openPanel(panel);
        }
      });
      if (idx === 0 && acc.getAttribute('data-expand-first') === 'true') {
        btn.setAttribute('aria-expanded', 'true');
        openPanel(panel);
      }
    });
  }

  function init() {
    var accs = document.querySelectorAll('[data-kpm-acc]');
    accs.forEach(initAcc);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
